import { g as d } from "../../utils-BOfnFgIH.js";
import { openBlock as e, createElementBlock as i, createElementVNode as t, createStaticVNode as l } from "vue";
import { _ as h } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIllustrationVectorVortex",
  props: {
    /**
     * The label of the illustration as read out by a screenreader. Leave this unset if your illustration is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the illustrations migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-illustration";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, n = ["aria-label", "data-qa", "aria-hidden"], u = ["fill"], f = ["fill"], w = ["fill"], p = ["id"], k = ["id"], v = ["id"];
function y(a, r, s, m, x, o) {
  return e(), i("svg", {
    "aria-label": s.ariaLabel,
    "data-qa": o.dataQA,
    "aria-hidden": o.ariaHidden,
    focusable: "false",
    role: "img",
    "data-name": "Vector Vortex",
    class: "d-illustration d-illustration--vector-vortex",
    width: "200",
    height: "169",
    viewBox: "0 0 200 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    r[3] || (r[3] = t("rect", {
      x: "64.57",
      y: "8.45",
      width: "126.38",
      height: "126.38",
      stroke: "var(--dt-color-surface-contrast)",
      "stroke-width": ".5",
      "stroke-dasharray": "3 3",
      id: "shadow"
    }, null, -1)),
    r[4] || (r[4] = t("path", {
      d: "M126.137 131.555c9.109 4.456 25.482-10.308 36.569-32.976 11.087-22.668 12.69-44.656 3.581-49.112-9.11-4.455-25.482 10.309-36.569 32.977-11.088 22.668-12.691 44.655-3.581 49.111Z",
      fill: "var(--dt-color-surface-contrast)",
      id: "shadow"
    }, null, -1)),
    r[5] || (r[5] = t("path", {
      d: "m160.021 46.403 6.994 3.42-.007 26.262-13.305 34.422-27.486 21.087-6.345-3.103 40.149-82.088Z",
      fill: "var(--dt-color-surface-contrast)",
      id: "shadow"
    }, null, -1)),
    t("path", {
      d: "M119.999 128.553c9.11 4.456 25.483-10.308 36.57-32.976s12.69-44.656 3.58-49.112c-9.109-4.455-25.482 10.309-36.569 32.977-11.087 22.668-12.69 44.656-3.581 49.111Z",
      fill: `url(#${a.uniqueID}paint0_linear_1103_211)`,
      id: "shadow"
    }, null, 8, u),
    r[6] || (r[6] = t("path", {
      d: "M74.517 40.08c8.032-6.192 27.031 4.99 42.437 24.976 15.406 19.986 21.384 41.206 13.352 47.397-8.031 6.191-27.031-4.991-42.437-24.977C72.464 67.491 66.486 46.271 74.517 40.08Z",
      fill: "var(--dt-color-surface-contrast)",
      id: "shadow"
    }, null, -1)),
    r[7] || (r[7] = t("path", {
      d: "m124.783 116.711 6.165-4.752-5.27-25.728-19.935-31.056-31.155-15.15-5.595 4.313 55.79 72.373Z",
      fill: "var(--dt-color-surface-contrast)",
      id: "shadow"
    }, null, -1)),
    t("path", {
      d: "M69.106 44.25c8.032-6.19 27.031 4.992 42.437 24.978 15.406 19.985 21.384 41.205 13.352 47.396-8.031 6.192-27.031-4.991-42.437-24.977-15.406-19.985-21.384-41.205-13.352-47.396Z",
      fill: `url(#${a.uniqueID}paint1_linear_1103_211)`,
      id: "shadow"
    }, null, 8, f),
    r[8] || (r[8] = t("path", {
      d: "m22.72 132.143.032.045c6.075 8.07 27.363 2.576 47.643-12.315 19.78-14.525 31.315-32.641 26.415-41.145l.024-.045-4.608-6.275-2.75 2.02c-9.462-1.343-25.43 4.546-40.817 15.845s-25.786 24.772-27.338 34.202l-2.75 2.02 4.108 5.594.02.027.02.027Z",
      fill: "var(--dt-color-surface-contrast)",
      id: "shadow"
    }, null, -1)),
    t("path", {
      d: "M18.655 126.609c6.003 8.174 27.357 2.692 47.696-12.243 20.34-14.936 31.962-33.67 25.96-41.843-6.003-8.174-27.357-2.692-47.696 12.243-20.34 14.936-31.962 33.67-25.96 41.843Z",
      fill: `url(#${a.uniqueID}paint2_linear_1103_211)`,
      id: "shadow"
    }, null, 8, w),
    r[9] || (r[9] = l('<path d="m9.985 33.356 54.582-24.91" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="m135.999 33.356 54.581-24.91" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="m135.999 159.736 54.581-24.91" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="m9.62 159.736 54.58-24.91" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><rect x="9.62" y="33.72" width="126.38" height="126.38" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="3 3" id="shadow"></rect><path d="M27.207 25.102h126.38v126.38" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="M47.207 16.102h126.38v126.38" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="m50.666 33.356 54.581-24.91m-54.581 25.62v125.82" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="m96.575 33.356 54.582-24.91m-54.582 25.62v125.82" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="M9.953 69.149h125.819m.216.222 54.582-24.91" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><path d="M9.953 113.326h125.819m.216.222 54.582-24.91" stroke="var(--dt-color-surface-contrast)" stroke-width=".5" stroke-dasharray="1 1" id="shadow"></path><rect x="34.42" y="67.2" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="112.38" y="111.38" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="48.28" y="139.53" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="94.63" y="42.95" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="151.8" y="68.93" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="67.34" y="23.46" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="171.72" y="50.74" width="3.9" height="3.9" fill="var(--dt-color-surface-primary)" stroke="var(--dt-color-surface-contrast)" stroke-width=".43" id="shadow"></rect><rect x="48.5" y="91.67" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect><rect x="94.41" y="132.38" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect><rect x="133.39" y="46.63" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect><rect x="132.52" y="14.14" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect><rect x="171.5" y="122.85" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect><rect x="151.58" y="87.34" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect><rect x="8.65" y="66.98" width="4.33" height="4.33" rx="2.17" fill="var(--dt-color-surface-contrast)" id="shadow"></rect>', 25)),
    t("defs", null, [
      t("linearGradient", {
        id: `${a.uniqueID}paint0_linear_1103_211`,
        x1: "135.57",
        y1: "58.81",
        x2: "133.45",
        y2: "131.5",
        gradientUnits: "userSpaceOnUse"
      }, [...r[0] || (r[0] = [
        t("stop", { "stop-color": "#7C52FF" }, null, -1),
        t("stop", {
          offset: ".49",
          "stop-color": "#F9008E"
        }, null, -1),
        t("stop", {
          offset: "1",
          "stop-color": "#F6AB3C"
        }, null, -1)
      ])], 8, p),
      t("linearGradient", {
        id: `${a.uniqueID}paint1_linear_1103_211`,
        x1: "98.34",
        y1: "109.46",
        x2: "81.7",
        y2: "38.67",
        gradientUnits: "userSpaceOnUse"
      }, [...r[1] || (r[1] = [
        t("stop", { "stop-color": "#7C52FF" }, null, -1),
        t("stop", {
          offset: ".49",
          "stop-color": "#F9008E"
        }, null, -1),
        t("stop", {
          offset: "1",
          "stop-color": "#F6AB3C"
        }, null, -1)
      ])], 8, k),
      t("linearGradient", {
        id: `${a.uniqueID}paint2_linear_1103_211`,
        x1: "64.81",
        y1: "72.05",
        x2: "29.21",
        y2: "135.46",
        gradientUnits: "userSpaceOnUse"
      }, [...r[2] || (r[2] = [
        t("stop", { "stop-color": "#7C52FF" }, null, -1),
        t("stop", {
          offset: ".49",
          "stop-color": "#F9008E"
        }, null, -1),
        t("stop", {
          offset: "1",
          "stop-color": "#F6AB3C"
        }, null, -1)
      ])], 8, v)
    ])
  ], 8, n);
}
const q = /* @__PURE__ */ h(c, [["render", y]]);
export {
  q as default
};
//# sourceMappingURL=vector-vortex.js.map
